module.exports = __webpack_public_path__ + "img/word-icon.0250637b.png";